exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".index-module__wrapper___3FCn_{padding:.4em 1.1em;border-radius:999px;font-weight:600;font-size:14px;color:#fff;min-height:40px;background-color:#9e7fc9;gap:8px;display:flex;align-items:center;cursor:pointer}.index-module__wrapper___3FCn_ svg{font-size:20px}.index-module__popup-wrapper___Z9Z9g{display:grid;gap:32px}.index-module__popup-wrapper___Z9Z9g h3{font-size:32px}.index-module__popup-wrapper___Z9Z9g p{color:#333}", ""]);

// exports
exports.locals = {
	"wrapper": "index-module__wrapper___3FCn_",
	"popup-wrapper": "index-module__popup-wrapper___Z9Z9g"
};